exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/zhaolinxu/GitHub/IdleAnt/~/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/zhaolinxu/GitHub/IdleAnt/~/postcss-loader?{"ident":"postcss"}!/Users/zhaolinxu/GitHub/IdleAnt/~/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/Users/zhaolinxu/GitHub/IdleAnt/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = 2